
import { defineComponent, ref, Ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import { Popup, DatetimePicker, Toast } from 'vant'
import { LogItem, CacheFaultBill } from '@/types/fault'
import getCacheFaultBillInfo from '@/compositions/fault/device'
import { DeviceItem } from '@/types/device'
import getRoute from '@/compositions/route'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { copy } from '@/utils/index'

export default defineComponent({
  name: 'Fault-Journal',
  components: {
    AppHeader,
    VanPopup: Popup,
    VanDatetimePicker: DatetimePicker,
  },
  setup() {
    const { cacheFaultBill, cacheCompleteDevices, cacheComponents } = getCacheFaultBillInfo()
    const store = useStore()
    const maxDate = new Date()
    const show: Ref<boolean> = ref(false)
    const filterDate = ref(new Date())
    const firstMasterDevice: DeviceItem = cacheCompleteDevices.value[0]
    const _selectedItems: LogItem[] = firstMasterDevice?.logs || []
    const rightCanClick: Ref<boolean> = ref(!!_selectedItems.length)
    const filterDateStr: Ref<string> = ref('选择日期')
    const { params } = getRoute()
    const sn: string = params.value.sn as string
    const formatter = (type: string, val: string): string => {
      if (type === 'year') {
        return `${val}年`
      }
      if (type === 'month') {
        return `${val}月`
      }
      if (type === 'day') {
        return `${val}日`
      }
      return val
    }
    const themeVars: { pickerConfirmActionColor: string } = {
      pickerConfirmActionColor: '#07c160',
    }
    return {
      themeVars,
      filterDateStr,
      rightCanClick,
      formatter,
      filterDate,
      _selectedItems,
      cacheFaultBill,
      cacheCompleteDevices,
      cacheComponents,
      show,
      $store: store,
      sn,
      maxDate,
    }
  },
  methods: {
    onConfirmDate(date: Date): void {
      this.filterDate = date
      this.filterDateStr = date ? dayjs(date).format('YYYY年MM月DD日') : '选择日期'
      this.onCancelDate()
    },
    onSelectLogs(items: LogItem[]): void {
      this.rightCanClick = !!items.length
      this._selectedItems = items
    },
    onCancelDate(): void {
      this.show = false
    },
    onRightClick() {
      if (!this._selectedItems?.length) {
        Toast('请选择报修日志')
        return
      }
      if (!this.cacheFaultBill?.id) {
        Toast('缺少报修单')
        return
      }
      const masterDevices: DeviceItem[] = copy(this.cacheCompleteDevices || [])
      const firstMasterDevice: DeviceItem = masterDevices[0]
      const sn: string = firstMasterDevice?.serial_number || ''
      if (sn !== this.sn) {
        Toast('该设备不是报修单的设备')
        return
      }
      const cacheFaultBill: CacheFaultBill = copy(this.cacheFaultBill)
      firstMasterDevice.logs = this._selectedItems
      cacheFaultBill.devices = [...this.cacheComponents, firstMasterDevice]
      this.$store.commit('setFaultBill', cacheFaultBill)
      this.$router.replace({ name: 'fault-form' })
    },
  },
})
